import React from 'react';
import PropTypes from 'prop-types';
import PanelTableList from "../../../common/layout/panel/PanelTableList";
import _ from 'lodash';
import {ACTION_TYPE, PRODUCTION_SCREEN} from "../../../../constants/constants";
import appActions from "../../../../actions/appActions";
import {bindActionCreators} from "redux";
import cutTicketActions from "../../../../actions/cutTicketActions";
import {setCutTicketQAProgressItems} from '../../../../functions/utils';
import {connect} from "react-redux";
import I18n from "i18n-js";
import ModalConfirm from "../../../common/modals/ModalConfirm";
import ProgressBar from "../../../common/fields/ProgressBar";

import icEditIcon from '../../../../stylesheets/images/ic-edit.svg';

class ViewQAProgress extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      actions: [],
      styleContractor: "",
      percent: {},
    };
  }

  componentWillMount() {
    const {data, cutTicketState} = this.props;
    this.getData(data);
    const {items, percent, styleContractor} = setCutTicketQAProgressItems(_.get(data, "order", {}), _.get(cutTicketState, "items", []), _.get(data, "style._id", ""));
    this.setState({items, percent, styleContractor});
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.cutTicketState, nextProps.cutTicketState)) {
      const {items, percent, styleContractor} = setCutTicketQAProgressItems(_.get(nextProps.data, "order", {}), _.get(nextProps.cutTicketState, "items", []), _.get(nextProps.data, "style._id", ""));
      this.setState({items, percent, styleContractor});
    }
  }

  getData(data) {
    const styleId = _.get(data, "style._id", "");
    const styleAndCutTicket = (_.get(data, "order.styleOrders", []).find(styleOrder => _.get(styleOrder, "style._id", "") === _.get(data, "style._id", "")));
    const query = JSON.stringify({_id: _.get(styleAndCutTicket, "cutTickets", []).reduce((arr, cut) => [...arr, cut._id],[])});
    const populate = "colors";
    styleId && this.props.cutTicketActions.getListCutTicket(styleId, {populate, query});
  }

  handleUpdateProgress(item) {
    let pageList = [...this.props.appState.pageList];
    pageList.push({screen: PRODUCTION_SCREEN.UPDATE_QA_PROGRESS, data: item});
    this.props.appActions.addPage(pageList);
  }

  editQAProgressByDate(item, data) {
    let pageList = _.cloneDeep(this.props.appState.pageList);
    this.props.appActions.addPage([...pageList, {
      screen: PRODUCTION_SCREEN.EDIT_QA_PROGRESS,
      data: {...data, selectedDate: item}
    }]);
  }

  deleteQAProgressByDate(item, data) {
    let {openModal, closeModal} = this.props.modal;
    let title = I18n.t('PageProduction.DELETE_PROGRESS');
    let confirmMessage = I18n.t('PageProduction.DeleteConfirm');
    let okFunction = () => this.deleteQAProgress(item, data);
    let modal = (<ModalConfirm
      title={title}
      confirmMessage={confirmMessage}
      messageOk={I18n.t('Btn.YES')}
      messageCancel={I18n.t('Btn.CANCEL')}
      handleClose={closeModal}
      handleOk={okFunction}/>);
    openModal(modal);
  }

  deleteQAProgress(item, data) {
    _.get(data, "_id", "") && _.get(item, "date", "") &&
    this.props.cutTicketActions.deleteCutTicketColorQAProgress(_.get(data, "_id", ""), {date: _.get(item, "date", "")}).then(res => {
      res && res.success && this.getData(this.props.data);
    });
  }

  renderPanelActions(item) {
    let {roles: {showEdit}} = this.props;
    return showEdit ? (
      <li>
        <span onClick={()=>this.handleUpdateProgress(item)}>
          <img src={icEditIcon} alt=""/>
          {I18n.t("PageProduction.UPDATE_PROGRESS")}
        </span>
      </li>
    ) : <li></li>;
  }

  render() {
    let {data, roles: {showCreate, showEdit, showDelete, showView}} = this.props;
    let {items, percent, styleContractor, actions} = this.state;
    actions= []
    if(showEdit){
      actions.push(() => {
        return {type: ACTION_TYPE.EDIT, click: (item, data) => this.editQAProgressByDate(item, data)};
      })
    }
    if(showDelete){
      actions.push(() => {
        return {type: ACTION_TYPE.DELETE, click: (item, data) => this.deleteQAProgressByDate(item, data)};
      })
    }
    return (
      <div id="content">

        <div className="pd-5 production_scroll">
          <ul className="content-header-title">
            <li>
              <p>{I18n.t("PageProduction.Style")} <span
                className="color-orange medium mg-left-50 size-16">{_.get(data, "style.style", "-")}</span></p>
            </li>
            {styleContractor &&
            <li className="mg-left-50">
              <p>{I18n.t("PageProduction.Contractor")} <span
                className="medium mg-left-50 size-16">{styleContractor}</span></p>
            </li>
            }
          </ul>
          <div className="qa-progress-progress-bar">
            <span>{I18n.t('PageProduction.Progress')}</span>
            <ProgressBar value1={_.get(percent, "value1",0)} value2={_.get(percent, "value2",0)}/>
          </div>
          <PanelTableList
            items={items||[]}
            actions={actions}
            dataKey={"qaProgressListByDate"}
            //onUpdateProgress={(item) => this.handleUpdateProgress(item)}
            renderPanelActions={(item) => this.renderPanelActions(item)}
          />
        </div>
      </div>
    );
  }
}

ViewQAProgress.propTypes = {
  appActions: PropTypes.object,
  cutTicketActions: PropTypes.object,
  appState: PropTypes.object,
  data: PropTypes.object,
  cutTicketState: PropTypes.object,
};

function mapStateToProps(state, ownProps) {
  return {
    appState: state.appState,
    authState: state.authState,
    cutTicketState: state.cutTicketState,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    appActions: bindActionCreators(appActions, dispatch),
    cutTicketActions: bindActionCreators(cutTicketActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewQAProgress);
